import type { ThreadMessage } from '@/types';

import {
  useAddMessageToThreadMutation,
  useGetAiChatThreadQuery,
  useGetResponsesFromThreadMutation,
} from '@/store/api/coachAiApi';


export const useGetThread = (threadId: string) =>
  useGetAiChatThreadQuery(
    { threadId },
    {
      skip: !threadId,
    },
  );

export const useAddThreadMessage = (threadId: string) => {
  const [trigger, result] = useAddMessageToThreadMutation();
  
  return {
    mutate: (content: string, options?: {
      onSuccess?: (data: ThreadMessage) => void;
      onError?: (error: unknown) => void;
      onSettled?: () => void;
    }) => {
      trigger({ content, threadId })
        .unwrap()
        .then((data) => {
          options?.onSuccess?.(data);
          options?.onSettled?.();
        })
        .catch((error) => {
          options?.onError?.(error);
          options?.onSettled?.();
        });
    },
    mutateAsync: (content: string) => trigger({ content, threadId }).unwrap(),
    ...result,
  };
};

export const useGetThreadResponses = (threadId: string) => {
  const [trigger, result] = useGetResponsesFromThreadMutation();
  
  return {
    mutate: (_?: undefined, options?: {
      onSuccess?: (data: ThreadMessage[]) => void;
      onError?: (error: unknown) => void;
      onSettled?: () => void;
    }) => {
      trigger({ threadId })
        .unwrap()
        .then((data) => {
          options?.onSuccess?.(data);
          options?.onSettled?.();
        })
        .catch((error) => {
          options?.onError?.(error);
          options?.onSettled?.();
        });
    },
    mutateAsync: () => trigger({ threadId }).unwrap(),
    ...result,
  };
};
